export const transactions = {
  data() {
    return {
      transactionsList: [
        {
          transactionId: 1,
          kindId: 4,
          createdAt: 1675524111878,
          balance: "0.000"
        },
        {
          transactionId: 2,
          kindId: 5,
          createdAt: 1677511311878,
          balance: "0.000"
        },
      ],
      
      transactionsFilterValue: null,
      iconsValues: { 
        0: {
          iconIndex: -1,
          iconTitle: "unknown"
        },
        1: {
          iconIndex: 2,
          iconTitle: "canceled"
        },
        2: {
          iconIndex: 2,
          iconTitle: "earned"
        },
        3: {
          iconIndex: 4,
          iconTitle: "spent"
        },
        4: {
          iconIndex: 3,
          iconTitle: "income"
        },
        5: {
          iconIndex: 4,
          iconTitle: "withdrawal"
        },
        6: {
          iconIndex: 2,
          iconTitle: "deposit wallet transfer"
        },
        7: {
          iconIndex: 2,
          iconTitle: "withrawal wallet transfer"
        },
        8: {
          iconIndex: 2,
          iconTitle: "exchange"
        },
        9: {
          iconIndex: 2,
          iconTitle: "pool deposit"
        },
        10: {
          iconIndex: 4,
          iconTitle: "pool withdrawal"
        },
        11: {
          iconIndex: 2,
          iconTitle: "contract unlocked"
        },
      },

    }
  },

  methods: {
    setDecimalPrice(price) {
      return Number(price).toFixed(2)
    },
    
    getCurrentIcon(kindId) {
      if (Object.keys(this.iconsValues).find(id => Number(id) === kindId) === undefined) return 1;
      return this.iconsValues[kindId]
    },
    
    addWeeksToDate(date, days, hours) {
      var result = new Date(date);
      if (days !== null) result.setDate(result.getDate() + days);
      else result.setHours(result.getHours() + hours);
      return result;
    },

    getDate(date) {
      return `${new Date(+date*1000).getDate()}.${new Date(+date*1000).getMonth()+1}.${new Date(+date*1000).getFullYear()}`
    }
  },
}